import Environment from '../Environment';
import mainService from '../mainService';

export function markNotificationAsRead(notificationId) {
  return mainService
    .put(`${Environment.notifications}/${notificationId}/read`)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function getNotifications(data) {
  return mainService
    .get(Environment.notifications, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function addNotificationSetting(data) {
  return mainService
    .post(Environment.notificationSetting, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function getNotificationSetting(data) {
  return mainService
    .get(Environment.notificationSetting, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function getNotificationsAdmin(data,page,size) {
  return mainService
    .get(Environment.adminNotifications+"?size="+size+"&page="+page, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function addNotificationAdmin(data) {
  return mainService
    .post(Environment.addAdminNotification, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function deleteNotificationAdmin(data, notificationId) {
  return mainService
    .delete(`${Environment.addAdminNotification + notificationId}`, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function updateNotificationAdmin(data, notificationId) {
  return mainService
    .put(Environment.updateAdminNotification + notificationId, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}

export function getNotificationAdmin(data,notificationId) {
  return mainService
    .get(Environment.notificationAdmin+notificationId, data)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
}
